import api from "../api";

export type VendorDto = {
  vendorId: number;
  vendorName: string;
  contactEmail?: string | null;
  phoneNumber?: string | null;
  address?: string | null;
  countryCode?: string | null;
  createdOn?: string | null;
  modifiedOn?: string | null;
};

export type CreateVendorRequest = {
  vendorName: string;
  contactEmail?: string;
  phoneNumber?: string;
  address?: string | null;
  countryCode?: string;
};

type ApiResponse<T = any> = { statusCode: number; message?: string; data?: T };

export async function fetchVendors(oem: string): Promise<VendorDto[]> {
  const { data } = await api.get<ApiResponse<VendorDto[]>>(`/Vendors/${oem}`);
  if (data?.statusCode === 200 && data.data) return data.data;
  return [];
}

export async function createVendor(oem: string, body: CreateVendorRequest): Promise<VendorDto> {
  const { data } = await api.post<ApiResponse<VendorDto>>(`/Vendors/${oem}`, body);
  if ((data?.statusCode === 201 || data?.statusCode === 200) && data.data) return data.data;
  throw new Error(data?.message || "Failed to create vendor");
}
